import histroy from '../../../history';
import { setLoaderStart, setLoaderComplete } from '../../loader/loader';
import { showToaster } from '../../../helpers/toastrMessgaes/showToaster';
import { addCategoryMutation } from '../../../lib/graphql';

export const addCategory = (
  id,
  name,
  description,
  logoImage,
  bannerImage,
  isPopular,
  badge,
  isJobPhotoRequired,
  isDirectBooking,
  travellingPrice,
  userServiceFeeValue,
  partnerServiceFeeValue,
  pricingType,
  status,
  currency,
  distanceType
) => {

  return async (dispatch, getState, { client }) => {

    try {

      dispatch(setLoaderStart('AddCategory'));

      const { data } = await client.mutate({
        mutation: addCategoryMutation,
        variables: {
          id,
          name,
          description,
          logoImage,
          bannerImage,
          isPopular: String(isPopular) === 'true' ? 1 : 0,
          badge,
          isJobPhotoRequired: String(isJobPhotoRequired) === 'true' ? 1 : 0,
          isDirectBooking: String(isDirectBooking) === 'true' ? 1 : 0,
          travellingPrice,
          userServiceFeeValue,
          partnerServiceFeeValue,
          pricingType,
          status,
          currency,
          distanceType
        }
      });

      dispatch(setLoaderComplete('AddCategory'));

      if (data?.addCategory?.status === 200) {
        showToaster({ messageId: 'addCatSuccess', requestContent: { id }, toasterType: 'success' });
        histroy.push('/siteadmin/category');
      } else {
        showToaster({ messageId: 'errorMessage', requestContent: { content: data?.addCategory?.errorMessage }, toasterType: 'error' });
      }
    } catch (err) {
      dispatch(setLoaderComplete('AddCategory'));
      showToaster({ messageId: 'catchMessage', requestContent: { content: err }, toasterType: 'error' });
    }
  }
}